import { Injectable, inject } from "@angular/core";

import { StateEmitter } from "../../../../common/libraries/emitter/state-emitter";
import { UserCustomizationService } from "../../../../common/services/api/resources/userCustomization/user-customization.service";

const debug = true;

interface Title {
  title: string;
}

@Injectable({ providedIn: "root" })
export class SignUpUserCustomizationService extends StateEmitter<Title> {
  private userCustomization = inject(UserCustomizationService);

  constructor() {
    super({
      title: ""
    });
  }

  get title(): string {
    debug && console.log("Signup2.UserCustomizationService: getTitle", this.stateValue.title);
    return this.stateValue.title || "";
  }

  set title(title: string) {
    debug && console.log("Signup2.UserCustomizationService: setTitle", title);
    this.stateStore.title = title;
    this.publishState();
  }

  saveTitle(): void {
    debug && console.log("Signup2.UserCustomizationService: saveTitle");
    this.userCustomization.userCustomizationPersonalPageInfoEdit({
      title: this.title || ""
    });
  }
}
